import * as React from 'react'

const SvgCopyFileIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={19} viewBox="0 0 16 19" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.147 8.187L11.36 4.36A1.218 1.218 0 0010.499 4H5.5c-.69 0-1.25.56-1.25 1.25v11.875c0 .69.56 1.25 1.25 1.25h8.75c.69 0 1.25-.56 1.25-1.25V9.048c0-.322-.128-.631-.353-.861zM10.5 5.269L14.203 9H10.5V5.269zm-5 11.856V5.25h3.75V9c0 .69.56 1.25 1.25 1.25h3.75v6.875H5.5zM1.75 10.25H.5V1.5C.5.81 1.06.25 1.75.25h8.75V1.5H1.75v8.75z"
      fill="#163250"
    />
  </svg>
)

export default SvgCopyFileIcon
